import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const LinkedIn: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36.005" height="34.417" viewBox="0 0 36.005 34.417">
            <path
                id="linkedin"
                d="M8.173,34.417V11.2H.455V34.417ZM4.315,8.023A4.024,4.024,0,1,0,4.366,0a4.023,4.023,0,1,0-.1,8.023h.05Zm8.13,26.394h7.718V21.449a5.283,5.283,0,0,1,.254-1.883,4.225,4.225,0,0,1,3.96-2.823c2.793,0,3.91,2.129,3.91,5.251V34.417H36V21.1c0-7.133-3.808-10.451-8.886-10.451a7.686,7.686,0,0,0-7.007,3.912h.052V11.195H12.446c.1,2.179,0,23.221,0,23.221Z"
                fill="#fff"
            />
        </svg>
    );
};

export default React.memo(LinkedIn);
